<div>
  Filter
  <button mat-mini-fab (click)="closeSidenav.emit()" color="white" class="button-right">
    <mat-icon>close</mat-icon>
  </button>
</div>
<hr />
<div class="text-left">
  <h4 class="text-center">{{ 'ORDERS.FILTER.STATUS' | translate }}</h4>
  <mat-radio-group
    color="primary"
    class="text-left"
    (change)="onSelected($event, FilterType.Status)"
    [value]="statusValue"
  >
    <mat-radio-button value="">{{ 'ORDERS.FILTER.ALL' | translate }}</mat-radio-button>
    <br />
    <mat-radio-button value="ORDERED">{{ 'ORDERS.FILTER.ORDERED' | translate }}</mat-radio-button>
    <br />
    <mat-radio-button value="ACTIVE">{{ 'ORDERS.FILTER.ACTIVE' | translate }}</mat-radio-button>
    <br />
    <mat-radio-button value="CANCELED">{{ 'ORDERS.FILTER.CANCELED' | translate }}</mat-radio-button>
    <br />
    <mat-radio-button value="INACTIVE">{{ 'ORDERS.FILTER.INACTIVE' | translate }}</mat-radio-button>
  </mat-radio-group>
</div>
<hr />
<div class="text-left">
  <h4 class="text-center">{{ 'ORDERS.FILTER.TIME_SPAN' | translate }}</h4>
  <mat-radio-group
    color="primary"
    class="text-left"
    (change)="onSelected($event, FilterType.Date)"
    [value]="timeSpanValue"
  >
    <mat-radio-button value="">{{ 'ORDERS.FILTER.WHOLE_TIME_SPAN' | translate }}</mat-radio-button>
    <br />
    <mat-radio-button value="last30Days">{{ 'ORDERS.FILTER.LAST_THREE_MONTHS' | translate }}</mat-radio-button>
    <br />
    <mat-radio-button value="last6Months">{{ 'ORDERS.FILTER.LAST_SIX_MONTHS' | translate }}</mat-radio-button>
    <br />
    <mat-radio-button value="lastYear">{{ 'ORDERS.FILTER.LAST_TWELVE_MONTHS' | translate }}</mat-radio-button>
    <br />
<!--    <mat-radio-button value="{{ date.getFullYear() - 1 }}">{{ date.getFullYear() - 1 }}</mat-radio-button>-->
<!--    <br />-->
<!--    <mat-radio-button value="{{ date.getFullYear() - 2 }}">{{ date.getFullYear() - 2 }}</mat-radio-button>-->
<!--    <br />-->
<!--    <mat-radio-button value="{{ date.getFullYear() - 3 }}">{{ date.getFullYear() - 3 }}</mat-radio-button>-->
  </mat-radio-group>
</div>
<hr />
<!--<div class="text-left">-->
<!--  <h4 class="text-center">{{ 'ORDERS.FILTER.TYPE' | translate }}</h4>-->
<!--  <mat-radio-group-->
<!--    color="primary"-->
<!--    class="text-left"-->
<!--    (change)="onSelected($event, FilterType.Type)"-->
<!--    [value]="typeFilterValue"-->
<!--  >-->
<!--    <mat-radio-button value="all">{{ 'ORDERS.FILTER.ALL' | translate }}</mat-radio-button>-->
<!--    <br />-->
<!--    <mat-radio-button value="article">{{ 'ORDERS.FILTER.ARTICLE' | translate }}</mat-radio-button>-->
<!--    <br />-->
<!--    <mat-radio-button value="SUBSCR">{{ 'ORDERS.FILTER.ABO' | translate }}</mat-radio-button>-->
<!--    <br />-->
<!--    <mat-radio-button value="digital content">{{ 'ORDERS.FILTER.DIGITAL_CONTENT' | translate }}</mat-radio-button>-->
<!--    <br />-->
<!--    <mat-radio-button value="event">{{ 'ORDERS.FILTER.EVENT' | translate }}</mat-radio-button>-->
<!--  </mat-radio-group>-->
<!--</div>-->
